import { render, staticRenderFns } from "./userfujinruyue.vue?vue&type=template&id=5242edce&scoped=true&"
import script from "./userfujinruyue.vue?vue&type=script&lang=js&"
export * from "./userfujinruyue.vue?vue&type=script&lang=js&"
import style0 from "./userfujinruyue.vue?vue&type=style&index=0&id=5242edce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242edce",
  null
  
)

export default component.exports